import { render } from "./DownloaderGroup.vue?vue&type=template&id=13d05454&scoped=true"
import script from "./DownloaderGroup.vue?vue&type=script&lang=js"
export * from "./DownloaderGroup.vue?vue&type=script&lang=js"

import "./DownloaderGroup.vue?vue&type=style&index=0&id=13d05454&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d05454"]])

export default __exports__